import {UTCDate} from "@date-fns/utc";
import classNames from "classnames";
import {differenceInSeconds} from "date-fns";

import {durationSecFn, roundDurationSecs} from "@/lib/format.tsx";
import {Service} from "@/lib/types/checks.ts";

import styles from "@/pages/dashboard/display/components/CheckCard.module.scss";

export const ServiceState = ({service}: {service: Service}) => {
  if (service.is_paused) {
    return <div className={classNames("text-muted", styles.checkCardStatValue)}>Paused</div>;
  } else if (service.cached_state_is_up) {
    const upDuration = service.cached_last_up_alert_at
      ? differenceInSeconds(new UTCDate(), service.cached_last_up_alert_at)
      : 0;
    return (
      <div className={classNames("text-success", styles.checkCardStatValue)}>
        Up for {durationSecFn(roundDurationSecs(upDuration))}
      </div>
    );
  } else {
    const downDuration = service.cached_last_down_alert_at
      ? differenceInSeconds(new UTCDate(), service.cached_last_down_alert_at)
      : 0;
    return (
      <div className={classNames("text-danger", styles.checkCardStatValue)}>
        Down for {durationSecFn(roundDurationSecs(downDuration))}
      </div>
    );
  }
};
